import { BsDatepickerConfig } from "ngx-bootstrap/datepicker";
import { TimepickerConfig } from "ngx-bootstrap/timepicker";

export const enum HttpMethodType {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  DELETE = 'DELETE',
  DELETE_MULTI = 'DELETE_MULTI'
}

export enum ERoleTypes {
  Standart = 1,
  Custom = 2
}

export const PAGINATION_OPTIONS = [10, 20, 30, 50, 100];
export const SMALL_PAGINATION_OPTIONS = [5, 10, 20, 30];

export const GRID_TEXTAREA_LIMIT = 20;

export const enum STATUS {
  SUCCESS = 200,
  CREATED = 201,
  BAD_REQUEST = 400,
  NOT_FOUND = 404,
  UNAUTHORISED = 401,
  NOT_ALLOWED = 405,
  FORBIDDEN = 403,
  ALREADY_EXISTS = 409,
  UNSUPPORTED_MEDIA_TYPE = 415
}

export const Messages = {
  /* Login */
  invalidCredentials: 'Invalid username/password'
};

export const DASHBOARD_URL = 'dashboard';

export const DEFAULT_URL = 'dashboard';

export const DATE_FORMAT = 'DD/MM/YYYY';
export const DATETIME_FORMAT = 'DD/MM/YYYY h:mm';
export const TIME_FORMAT = 'h:mm a';

export const getEnumKeyByValue = (object: any, value: any): number => {
  return Number(
    Object.keys(object).find(
      (key) => object[key].toLowerCase() === value.toLowerCase()
    )
  );
};

export const DEFAULT_PROFILE_IMAGE = 'assets/images/user.png';


export const DatePickerDefaultConfig: Partial<BsDatepickerConfig> = {
  keepDatepickerOpened: true,
  rangeInputFormat: 'DD/MM/YYYY', dateInputFormat: 'DD/MM/YYYY'
}

export const DateTimePickerDefaultConfig: Partial<BsDatepickerConfig> = {
  withTimepicker: true, keepDatepickerOpened: true,
  rangeInputFormat: 'DD/MM/YYYY, h:mm a', dateInputFormat: 'DD/MM/YYYY, h:mm a'
}

export const TimePickerDefaultConfig: Partial<TimepickerConfig> = {
  showMeridian: false
}